const EmployeeDiscountIconMenu = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="32"
      height="32"
      rx="6.64935"
      fill="url(#paint0_linear_4674_25498)"
      fill-opacity="0.1"
    />
    <path
      d="M16.2698 7.52851C16.5549 7.61403 16.783 7.69955 17.011 7.89911C17.2391 8.09866 18.0088 8.95389 18.2654 9.06792C18.5219 9.18195 18.4079 9.09643 18.4934 9.09643C19.2631 9.09643 20.0899 8.66882 20.8311 9.06792C21.5723 9.46703 21.6008 10.6358 21.8003 11.4911C21.9999 12.3463 22.0569 11.8617 22.3135 12.0327C23.1117 12.4888 24.1094 12.7454 24.1094 13.8572C24.1094 14.5699 23.4538 15.2256 23.3112 15.8528C23.1687 16.4799 23.3112 16.2234 23.4253 16.4514C23.7674 17.2211 24.366 17.8483 23.9954 18.7605C23.6248 19.6728 22.7126 19.7298 22.0569 20.1574C21.4012 20.585 21.8288 20.3285 21.7718 20.5565C21.6008 21.2692 21.6578 22.2385 21.0876 22.7801C20.5175 23.3218 19.3487 22.9797 18.4364 22.9512C17.5242 22.9227 18.1798 22.9797 18.0373 23.0937C17.4671 23.5498 16.954 24.4051 16.1558 24.4906C15.3576 24.5761 14.93 24.063 14.4168 23.5783C13.9037 23.0937 13.9037 22.9227 13.5046 22.9227C12.6208 22.9512 11.7086 23.4643 10.9104 22.7801C10.2832 22.267 10.3687 21.2692 10.1977 20.528C10.0266 19.7868 9.94112 20.1574 9.68455 19.9864C9.08588 19.6443 8.25916 19.4162 8.00259 18.7035C7.74602 17.9908 8.25916 17.1926 8.57275 16.4229C8.88633 15.6532 8.74379 16.0808 8.68678 15.8243C8.54424 15.1971 7.86005 14.5414 7.88856 13.8287C7.88856 12.6884 8.88633 12.4603 9.68455 12.0042C10.4828 11.5481 10.1122 11.8047 10.1977 11.4626C10.4257 10.6073 10.2832 9.52405 11.1669 9.03942C12.0507 8.55479 12.7349 9.03942 13.5046 9.06792C14.2743 9.09643 13.6471 9.06792 13.7326 9.03942C13.9892 8.95389 14.7019 8.09866 14.987 7.8706C15.2721 7.64254 15.4431 7.58552 15.7282 7.5H16.1843L16.2698 7.52851ZM13.9607 11.6051C12.5353 11.7191 11.7941 13.4581 12.7349 14.5414C13.6756 15.6247 14.987 15.3396 15.6141 14.2848C16.2413 13.23 15.3576 11.4911 13.9322 11.6051H13.9607ZM19.1776 12.2893C19.0921 12.2893 19.0066 12.3463 18.9496 12.4033L12.4498 18.9031C12.1362 19.3592 12.6493 19.9009 13.134 19.5873L19.6622 13.059C19.9188 12.6884 19.6622 12.2323 19.1776 12.2893ZM17.7237 16.822C17.1536 16.9075 16.5549 17.3922 16.3553 17.9053C15.7282 19.5873 17.6097 21.0412 19.0351 20.0434C20.546 18.9601 19.6052 16.594 17.7237 16.822Z"
      fill="#052351"
    />
    <path
      d="M14.6734 13.9712C13.9607 14.6839 12.8489 13.7147 13.4191 12.9165C13.9892 12.1182 15.4716 13.1445 14.6734 13.9712Z"
      fill="#052351"
    />
    <path
      d="M17.4101 18.0194C18.1228 17.3067 19.2346 18.276 18.6645 19.0742C18.0943 19.8724 16.6119 18.8462 17.4101 18.0194Z"
      fill="#052351"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4674_25498"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0062FF" />
        <stop offset="1" stop-color="#004BC2" />
      </linearGradient>
    </defs>
  </svg>
)

export default EmployeeDiscountIconMenu
